import React, { Fragment, useState, useEffect } from "react";
import Select from "react-select";
import { Dropdown } from "react-bootstrap";
import { Form, FormGroup, Label, Input } from "reactstrap";
import ReactPanZoom from "react-image-pan-zoom-rotate";
import {
  Pagination,
  PaginationItem,
  PaginationLink,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";

import { Link } from "react-router-dom";
import { SRLWrapper } from "simple-react-lightbox";

import RctCollapsibleCard from "../RctCollapsibleCard/RctCollapsibleCard";
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import { TimePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
//** Import Image */
import food1 from "./../../../../images/foods/food1.jpg";
import food2 from "./../../../../images/foods/food2.jpg";
import food4 from "./../../../../images/foods/food4.jpg";
import food9 from "./../../../../images/foods/food9.png";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/Step";
import StepButton from "@material-ui/core/StepButton";
import Typography from "@material-ui/core/Typography";
import FoodMenuForm from "./FoodMenuForm";
import VariantItemForm from "./VariantItemForm";
import AddOnForm from "./AddOnForm";
import { Accordion } from '@mui/material';
// import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { makeStyles } from "@material-ui/core/styles";
import {
  GetOutletTimingList,
  SlotMasterList, saveofMenuAVL,
  saveslotmaster, deleteodmenuAVL,
  updateslotmaster, getMenuAvailalbitListApi,
  saveoutletDetails, getRoleMaster, getoutletListMaster, addOutletSubMenuItem, UpdateOutletSubMenuItem,
  gettstaffListMaster, getMenuMasterList, saveMainMenuName, updatePWDstaffDetails, saveSubMenuName
} from "../../../../apiservicescall/api";
import swalMessage from "@sweetalert/with-react";
import swal from "sweetalert";

import {
  Table,
  Badge,
  Row,
  Card,
  Col,
  Button,
  Container,
  ListGroup,
} from "react-bootstrap";
import { CardTitle, CardBody } from "reactstrap";
import Multiselect from 'multiselect-react-dropdown';
import SelectSearch, { fuzzySearch } from "react-select-search";



const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    backgroundColor: "#00b53b"
    // backgroundColor: "red"
  },
  rootExpanded: {
    flexGrow: 1,
    width: "100%",
    // backgroundColor: "#00b53b"
    // backgroundColor: "blue"
  }
}));


const FoodMenuManagment = (props) => {

  const options = [
    { value: "chocolate", label: "Chocolate" },
    { value: "strawberry", label: "Strawberry" },
    { value: "vanilla", label: "Vanilla" },
  ];


  const listItem = ["Breakfast", "Lunch", "Dinner", "Dosas"];
  const [menuFoodItemModal, setMenuFoodItemModal] = useState(false);
  const [subMenuModal, setSubMenuModal] = useState(false);
  const [mainMenuModal, setMainMenuModal] = useState(false);
  const [foodItemTiming, setFoodItemTiming] = useState(false);

  const [checkeditem, setCheckeditem] = useState(false);


  const [isView, setIsview] = useState(false);
  const [isedit, setIsedit] = useState(false);
  const [tempModalPopupValue, setTempModalPopupValue] = useState();
  const [openImagePopup, setOpenImagePopup] = useState();
  //stepper//
  const [activeStep, setActiveStep] = useState(0);
  const steps = getSteps();
  const [completed, setCompleted] = useState(new Set());
  const [skipped, setSkipped] = useState(new Set());

  const [category, setCategory] = useState([]);

  const [variant, setVariant] = useState([
    { label: "Size", value: "Size" },
    { label: "Quantity", value: "Quantity" },
    { label: "Rice", value: "Rice" },
  ]);

  const [typeadd, setTypeadd] = useState([
    { label: "Extras", value: "Extras" },
    { label: "Toppings", value: "Toppings" },
    { label: "Scoope", value: "Scoope" },
  ]);

  const [menuMasterList, setMenuMasterList] = useState([]);

  const [userDetails, setUserDetails] = useState(
    JSON.parse(localStorage.getItem("userDetails"))
  );

  const [outletvalue, setOutletvalue] = useState({
    label: "",
    value: "",
  });

  const [menuSubmenuItems, setMenuSubmenuItems] = useState({
    outletCode: userDetails?.outletResponses[0]?.outletCode,
    status: "A",
    menuId: "",
    menuName: "",
    subMenuId: "",
    subMenuName: "",
    selectedMainmenuItem: "",
    selectedSubmenuItem: "",

    selectedMainmenuItemValue: "",
    selectedSubmenuItemValue: "",

    selectedIndividualFoodItem: "",
    selectedIndividualFoodItemName: "",


    startTime: "",
    endTime: "",
    itemDesc: "",
    itemName: "",
    itemPrice: "",
    itemQuantity: "",
    itemType: false,
    itemFoodImage: "",
    itemFoodPath: "",
    varient: "",
    itemId: "",
    status: "",
  });


  const [selectedFoodSubmenuItem, setSelectedFoodSubmenuItem] = useState([]);

  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);
  const rootClass = expanded ? classes.rootExpanded : classes.root;
  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const [selectedOutlet, setSelectedOutlet] = useState(
    JSON.parse(localStorage.getItem("selectedOutlet"))
  );

  const [additemSubmenuMaster, setAdditemSubmenuMaster] = useState([]);
  const [timingslist, setTimingslist] = useState([]);
  const [slotmaster, setSlotmaster] = useState([]);
  const [menuAvailablityMaster, setMenuAvailablityMaster] = useState([]);

  const [menuAvailablityListSaveUpdateDeleteMaster, setMenuAvailablityListSaveUpdateDeleteMaster]
    = useState([
      {
        outletCode: userDetails?.outletResponses[0]?.outletCode,
        dayId: "1",
        dayName: "Monday",
        dayStatus: "true",
        // slotId: []
      },
      {
        outletCode: userDetails?.outletResponses[0]?.outletCode,
        dayId: "2",
        dayName: "Tuesday",
        dayStatus: "true",
        // slotId: []
      },
      {
        outletCode: userDetails?.outletResponses[0]?.outletCode,
        dayId: "3",
        dayName: "Wednesday",
        dayStatus: "true",
        // slotId: []
      },
      {
        outletCode: userDetails?.outletResponses[0]?.outletCode,
        dayId: "4",
        dayName: "Thursday",
        dayStatus: "true",
        // slotId: []
      },
      {
        outletCode: userDetails?.outletResponses[0]?.outletCode,
        dayId: "5",
        dayName: "Friday",
        dayStatus: "true",
        // slotId: []
      },
      {
        outletCode: userDetails?.outletResponses[0]?.outletCode,
        dayId: "6",
        dayName: "Saturday",
        dayStatus: "true",
        // slotId: []
      },
      {
        outletCode: userDetails?.outletResponses[0]?.outletCode,
        dayId: "7",
        dayName: "Sunday",
        dayStatus: "true",
        // slotId: []
      }
    ]);

  const [dropdownMaster, setDropdownMaster] = useState([
    { label: "All Day", value: "1" },
    { label: "Day Slot", value: "2" },
    // { label: "Week Days Only", value: "3" },
    // { label: "Week End Only", value: "4" }
  ]);

  const [dropdownMasterDay, setDropdownMasterDay] = useState([
    { label: "Monday", value: "1" },
    { label: "Tuesday", value: "2" },
    { label: "Wednesday", value: "3" },
    { label: "Thursday", value: "4" },
    { label: "Friday", value: "5" },
    { label: "Saturday", value: "6" },
    { label: "Sunday", value: "7" }
  ]);

  const [dropdownslotmaster, setDropdownslotmaster] = useState([]);
  const [dropdownMastervalue, setDropdownMastervalue] = useState({ label: "", name: "" });


  useEffect(() => {
    getMenuMasterListMasterApi();
    let outletCode = userDetails?.outletResponses[0]?.outletCode;
    getoutlettimeList(outletCode);
    getslotmaster(outletCode);
  }, []);


  const getoutlettimeList = async (outletCode) => {
    let getoutletList = await GetOutletTimingList(outletCode);
    let getoutletListValue = getoutletList?.data?.data;
    setTimingslist(getoutletListValue);
    console.log("getoutletListValue", getoutletListValue);
  };

  const getslotmaster = async (outletCode) => {
    let getslotList = await SlotMasterList(outletCode);
    let getslotListValue = getslotList?.data?.data;
    await setSlotmaster(getslotListValue);

    let tempslotMasteroutmaster = getslotListValue.map(({ slotName, slotId }) => ({
      label: slotName,
      value: slotId,
    }));

    await setDropdownslotmaster(tempslotMasteroutmaster)

    // let enablebollean = getslotListValue.map(obj => {
    //   obj["itemAvailablity"] = true;
    //   return { ...obj };
    // })
    // console.log("getslotListValue", getslotListValue);
    // console.log("enablebollean", enablebollean);

    // setMenuAvailablityListSaveUpdateDeleteMaster(menuAvailablityListSaveUpdateDeleteMaster =>
    //   menuAvailablityListSaveUpdateDeleteMaster.map(obj => {
    //     obj["slotId"] = getslotListValue;
    //     return { ...obj };
    //   }),
    // );

    // console.log("menuAvailablityListSaveUpdateDeleteMaster123", menuAvailablityListSaveUpdateDeleteMaster);
  };


  const getMenuMasterListMasterApi = async () => {
    let outletCode = userDetails?.outletResponses[0]?.outletCode;
    // console.log("vjdata", data);
    let getoutletList = await getMenuMasterList(outletCode);
    let getstaffListValue = getoutletList?.data?.data;
    // console.log("getstaffListValue", getstaffListValue);
    setMenuMasterList(getstaffListValue);
    menumasterlabelvalue();

    setMenuSubmenuItems({
      menuId: menuSubmenuItems?.menuId,
      menuName: menuSubmenuItems?.menuName,
      selectedSubmenuItem: menuSubmenuItems?.selectedSubmenuItem,
      selectedSubmenuItemValue: menuSubmenuItems?.selectedSubmenuItemValue,
      subMenuId: menuSubmenuItems?.subMenuId,
      selectedMainmenuItem: menuSubmenuItems?.selectedMainmenuItem,
      selectedMainmenuItemValue: menuSubmenuItems?.menuId
    });
  };

  const menumasterlabelvalue = () => {
    let outmaster = menuMasterList && menuMasterList.map(({ menuId, menuName }) => ({
      label: menuName,
      value: menuId,
    }));
    setCategory(outmaster);
  }


  const dropdownHandling = async (type, event) => {
    
    console.log("type", type);
    console.log("event", event);
    // if (event?.value == "2") {
    //   setDropdownMasterDay([])
    // }
    setDropdownMastervalue(event);
    console.log("dropdownMastervalue", dropdownMastervalue);
    // const [dropdownMastervalue, ] = useState({ label: "", name: "" });
  }


  const alldayallsotBoolean = async () => {
    // console.log("checkeditem00001 Current", checkeditem);
    // console.log("checkeditem00002 OPP", !checkeditem);
    // console.log("checkeditem00003 Current", menuAvailablityListSaveUpdateDeleteMaster);
    if (checkeditem === true) {
      await setCheckeditem(false);
      await setMenuAvailablityListSaveUpdateDeleteMaster(
        menuAvailablityListSaveUpdateDeleteMaster.map(items => ({
          ...items,
          slotId: items.slotId.map(object1 => {
            return { ...object1, itemAvailablity: false }
          })
        })));
    } else if (checkeditem === false) {
      await setCheckeditem(true);
      await setMenuAvailablityListSaveUpdateDeleteMaster(
        menuAvailablityListSaveUpdateDeleteMaster.map(items => ({
          ...items,
          slotId: items.slotId.map(object1 => {
            return { ...object1, itemAvailablity: true }
          })
        })));
    };
    // console.log("checkeditem00004 Upd", menuAvailablityListSaveUpdateDeleteMaster);
    // console.log("checkeditem00005 Upd", checkeditem);
  };

  const nestedLevelItemCheck = async (dayId, slotData) => {
    await setMenuAvailablityListSaveUpdateDeleteMaster(
      menuAvailablityListSaveUpdateDeleteMaster.map(items => ({
        ...items,
        slotId: items.slotId.map(object1 => ((items.dayId == dayId && object1.slotId == slotData?.slotId) ? { ...object1, itemAvailablity: !slotData?.itemAvailablity } : object1))
      })));
    // console.log("checkeditem0000", menuAvailablityListSaveUpdateDeleteMaster);
  };


  const apiMasterCallOfmenuAvailablityListSaveUpdateDeleteMaster = async () => {
    console.log("current", menuAvailablityListSaveUpdateDeleteMaster);
    console.log("current", menuSubmenuItems);


    // setMenuAvailablityListSaveUpdateDeleteMaster(menuAvailablityListSaveUpdateDeleteMaster =>
    //   menuAvailablityListSaveUpdateDeleteMaster.map(obj => {
    //     obj["mainMenuId"] = menuSubmenuItems?.mainMenuId;
    //     obj["subMenuId"] = menuSubmenuItems?.subMenuId;
    //     obj["menuId"] = menuSubmenuItems?.selectedIndividualFoodItem;
    //     return { ...obj };
    //   }),
    // );

    // let saveupdateMasterOFmenuAvailablityListSaveUpdateDeleteMaster =
    //   menuAvailablityListSaveUpdateDeleteMaster.map(items => ({
    //     ...items,
    //     slotId: items.slotId.filter((item) => item.itemAvailablity === true)
    //       .map((item) => {
    //         return item["slotId"];
    //       })
    //   }));

    // let filtetredsave =
    //   saveupdateMasterOFmenuAvailablityListSaveUpdateDeleteMaster.map(obj => {
    //     obj["mainMenuId"] = menuSubmenuItems?.mainMenuId;
    //     obj["subMenuId"] = menuSubmenuItems?.subMenuId;
    //     obj["menuId"] = menuSubmenuItems?.selectedIndividualFoodItem;
    //     return { ...obj };
    //   });


    // let deleteMasterOFmenuAvailablityListSaveUpdateDeleteMaster =
    //   menuAvailablityListSaveUpdateDeleteMaster.map(items => ({
    //     ...items,
    //     slotId: items.slotId.filter((item) => item.itemAvailablity === false)
    //       .map((item) => {
    //         return item["slotId"];
    //       })
    //   }));


    // let filtetredupdate =
    //   deleteMasterOFmenuAvailablityListSaveUpdateDeleteMaster.map(obj => {
    //     obj["mainMenuId"] = menuSubmenuItems?.mainMenuId;
    //     obj["subMenuId"] = menuSubmenuItems?.subMenuId;
    //     obj["menuId"] = menuSubmenuItems?.selectedIndividualFoodItem;
    //     return { ...obj };
    //   });

    // let savereqformenusubmenu = await saveofMenuAVL(filtetredsave);
    // let deletereqformenusubmenu = await deleteodmenuAVL(filtetredupdate);

    // console.log("finalupdate0001", menuAvailablityListSaveUpdateDeleteMaster);
    // console.log("finalupdate0002", filtetredsave);
    // console.log("finalupdate0003", filtetredupdate);

    swal("Success!", "Time Slots Updated", "success");
    setFoodItemTiming(!foodItemTiming);
  };



  const saveMenuSubmenu = async (key) => {
    let data = "";
    data = {
      outletCode: userDetails?.outletResponses[0]?.outletCode,
      status: "A",
      menuId: outletvalue?.value || "",
      menuName: menuSubmenuItems?.menuName || "",
      subMenuId: menuSubmenuItems?.subMenuId || "",
      subMenuName: menuSubmenuItems?.subMenuName || "",
    };
    let reqformenusubmenu;
    if (key === "Maninmenu") {
      reqformenusubmenu = await saveMainMenuName(data);
    } else if (key === "SubManinmenu") {
      reqformenusubmenu = await saveSubMenuName(data);
    } else {
    }


    if (reqformenusubmenu.data.status === true) {
      setMenuSubmenuItems({});

      setMainMenuModal(false)
      setSubMenuModal(false)
      setMenuFoodItemModal(false)
      setFoodItemTiming(false)

      getMenuMasterListMasterApi();
      // getstaffMasterList();     
      // setStaffvalue({});
      // setOutletvalue({});
      setIsview(false);
      setIsedit(false);
      // setLargeModal(!largeModal);

      if (key === "Maninmenu") {
        swal("Success!", "Menu Created", "success");
      } else {
        swal("Success!", "Sub Menu Updated", "success");
      }
    } else {
      // await this.setState({ reload: false });
      // NotificationManager.warning("Invalid Data Format");
      // this.setState({ addNewUserModal: true });

      setMainMenuModal(!mainMenuModal)
      getMenuMasterListMasterApi();

      swal("Oops", "Error, Please Try Later", "error");
      // setIsview(false);
      // setIsedit(false);
      // setLargeModal(!largeModal);
      // getstaffMasterList();
    }
  };

  const onChangeCommonpopup = (key, value) => {
    
    console.log("key", key)
    console.log("value", value)

    // if (key == "itemType") {
    //   const newFormData = { ...menuSubmenuItems };
    //   newFormData[key] = value.target.checked;
    //   setMenuSubmenuItems(newFormData);
    // } else 

    if (key == "itemFoodImage") {
      const newFormData = { ...menuSubmenuItems };
      newFormData[key] = value.target.files[0];
      setMenuSubmenuItems(newFormData);
    } else {
      const newFormData = { ...menuSubmenuItems };
      newFormData[key] = value;
      setMenuSubmenuItems(newFormData);
    }

    console.log("menuSubmenuItemsafteronchange", menuSubmenuItems)


  }

  const onChangeCommonpopupsetOutletvalue = (key, event) => {
    // 
    // console.log("event", event);
    // setAdditemSubmenuMaster([]);
    if (key == "mainmenuname") {
      setMenuSubmenuItems({
        menuId: event.value,
        menuName: event.label,
        selectedMainmenuItem: event
      });
      const tempstatemaster = menuMasterList
        .filter((item) => item.menuId == event.value)
        .map((item) => {
          return item.subMenu
        });

      let additemSubmenuMasterresponse = tempstatemaster[0]?.map(({ subMenuName, subMenuId }) => ({
        label: subMenuName,
        value: subMenuId,
      }));

      console.log("additemSubmenuMasterresponse", additemSubmenuMasterresponse);
      setAdditemSubmenuMaster(additemSubmenuMasterresponse);
    }

    if (key == "submainmenuname") {
      // 
      // console.log("menuSubmenuItems?.menuId", menuSubmenuItems);

      setMenuSubmenuItems({
        selectedSubmenuItem: event.label,
        subMenuId: event.value,
        subMenuName: event.label,

        menuId: menuSubmenuItems?.menuId,
        menuName: menuSubmenuItems?.menuName
        // menuName: event.label,
        // selectedMainmenuItem: event

      });

      const tempstatemaster = menuMasterList
        .filter((item) => item.menuId == menuSubmenuItems?.menuId)
        .map((item) => {
          return item?.subMenu[0].subMenuItem
        });

      console.log("tempstatemaster", tempstatemaster);

      // let additemSubmenuMasterresponse = tempstatemaster && tempstatemaster.length > 0 && tempstatemaster?.map(({ itemName, itemId }) => ({
      //   label: itemName,
      //   value: itemId,
      // }));      
      // console.log("additemSubmenuMasterresponse", additemSubmenuMasterresponse);

    }

  }


  function getSteps() {
    // return ["Add Item Details", "Variant Item & Add-Ons"];
    return ["Add Item Details"];
  }

  function getStepContent(step) {
    switch (step) {
      case 0:
        return <FoodMenuForm menuSubmenuItems={menuSubmenuItems} additemSubmenuMaster={additemSubmenuMaster} onChangeCommonpopup={onChangeCommonpopup} category={category} onChangeCommonpopupsetOutletvalue={onChangeCommonpopupsetOutletvalue} />;

      case 1:
        return <VariantItemForm variant={variant} />;

      /* case 2:
        return <AddOnForm typeadd={typeadd} />; */
      /* case 3:
        return <BankDetails />; */
      /*  default:
        return "unknown step"; */
    }
  }

  const chkImgFile = (file) => {
    // console.log("file", file);
    if (file) {
      const fileArr = file.split(".");
      const fileExt = fileArr[fileArr.length - 1];
      if (fileExt.toLowerCase() == "pdf") {
        return false;
      } else {
        return true;
      }
    }
  };
  const skippedSteps = () => {
    return skipped.size;
  };
  const isStepOptional = (step) => {
    return step === 1 || step === 2;
  };

  const isStepSkipped = (step) => {
    return skipped.has(step);
  };

  const handleStep = (step) => {
    console.log("step", step);
    setActiveStep(step);
  };
  const totalSteps = () => {
    return getSteps().length;
  };
  const completedSteps = () => {
    return completed.size;
  };

  const isLastStep = () => {
    return activeStep === totalSteps() - 1;
  };

  const allStepsCompleted = () => {
    return completedSteps() === totalSteps() - skippedSteps();
  };

  const submitFoodItemApi = async () => {
    
    console.log("menuSubmenuItems", menuSubmenuItems)
    console.log("menuSubmenuItems", menuSubmenuItems?.selectedMainmenuItem)
    // setMenuFoodItemModal(false);
    let data = "";
    data = {
      outletCode: userDetails?.outletResponses[0]?.outletCode,
      status: "A",
      menuId: menuSubmenuItems?.menuId,
      // menuName: menuSubmenuItems?.menuName,
      menuName: menuSubmenuItems?.selectedMainmenuItem,
      // menuId: menuSubmenuItems?.menuId || menuSubmenuItems?.selectedMainmenuItem?.value,
      // menuName: menuSubmenuItems?.menuName || menuSubmenuItems?.selectedMainmenuItem?.label,
      subMenuId: menuSubmenuItems?.subMenuId,
      subMenuName: menuSubmenuItems?.selectedSubmenuItem,

      startTime: "",
      endTime: "",
      itemDesc: menuSubmenuItems?.itemDesc,
      itemName: menuSubmenuItems?.itemName,
      itemPrice: menuSubmenuItems?.itemPrice,
      itemId: menuSubmenuItems?.itemId || "",
      itemQuantity: "1",
      itemType: menuSubmenuItems?.itemType === true ? "veg" : "nonveg",
      itemFoodImage: menuSubmenuItems?.itemFoodImage,
      varient: [
        {
          varientType: "",
          small: "",
          medium: "",
          large: ""
        }
      ]
    };

    console.log("vjjv", data);

    let formData = new FormData();
    for (var key in data) {
      if (Array.isArray(data[key])) {
        data[key].forEach((obj, index) => {
          let keyName = [key, "[", index, "]"].join("");
          formData.append("file", obj);
        });
      } else {
        formData.append(key, data[key]);
      }
    }

    // console.log("formData", formData);
    // console.log("menuSubmenuItems?.itemId", menuSubmenuItems?.itemId);

    let reqformenusubmenu;
    if (menuSubmenuItems?.itemId == undefined) {
      reqformenusubmenu = await addOutletSubMenuItem(formData);
    } else {
      reqformenusubmenu = await UpdateOutletSubMenuItem(formData);
    }

    if (reqformenusubmenu.data.status === true) {
      if (menuSubmenuItems?.itemId == undefined) {
        swal("Success!", "Item Added", "success");
      } else {
        swal("Success!", "Item Updated", "success");
      }

      // setMenuMasterList([]);

      setMenuSubmenuItems({});
      setMenuFoodItemModal(false)
      setFoodItemTiming(false)
      getMenuMasterListMasterApi();
      setMainMenuModal(false)
      setSubMenuModal(false)
    } else {

      swal("Oops", "Error, Please Try Later", "error");

      // setMenuMasterList([]);

      setMenuFoodItemModal(false)
      setFoodItemTiming(false);
      getMenuMasterListMasterApi();
      setMainMenuModal(false)
      setSubMenuModal(false);
    }
  };


  const getMenuAvailalbitList = async () => {
    // 
    console.log("menuSubmenuItems", menuSubmenuItems)
    // console.log("menuSubmenuItems", typeof userDetails?.outletResponses[0]?.outletCode)
    // console.log("menuSubmenuItems", menuSubmenuItems?.selectedMainmenuItem?.value)
    let outletCode = userDetails?.outletResponses[0]?.outletCode;
    let mainMenuId = menuSubmenuItems?.menuId;
    let subMenuId = menuSubmenuItems?.subMenuId;
    let menuId = menuSubmenuItems?.selectedIndividualFoodItem;
    let menuavailityList = await getMenuAvailalbitListApi(outletCode, mainMenuId, subMenuId, menuId);
    // swal("Oops", "Error, Please Try Later", "error");
    await setMenuAvailablityMaster(menuavailityList.data?.data);
    await setMenuSubmenuItems({
      mainMenuId: menuSubmenuItems?.menuId,
      subMenuId: menuSubmenuItems?.subMenuId,
      selectedIndividualFoodItem: menuSubmenuItems?.selectedIndividualFoodItem,
      selectedIndividualFoodItemName: menuSubmenuItems?.selectedIndividualFoodItemName
    });
    // setMenuAvailablityListSaveUpdateDeleteMaster(menuAvailablityListSaveUpdateDeleteMaster =>
    //   menuAvailablityListSaveUpdateDeleteMaster.map(obj => {
    //     obj["slotId"] = enablebollean;
    //     return { ...obj };
    //   }),
    // );
    console.log("menuAvailablityListSaveUpdateDeleteMaster", menuAvailablityListSaveUpdateDeleteMaster)
    // console.log("menuavailityList", menuavailityList.data?.data);
    console.log("length", menuavailityList.data?.status);

    if (menuavailityList.data?.status === true) {
      

      setMenuAvailablityListSaveUpdateDeleteMaster(menuavailityList.data?.data);

      // await setMenuAvailablityListSaveUpdateDeleteMaster(menuAvailablityListSaveUpdateDeleteMaster =>
      //   menuAvailablityListSaveUpdateDeleteMaster.map(obj => {
      //     obj["slotId"] = menuavailityList.data?.data;
      //     return { ...obj };
      //   }),
      // );

      // await setMenuAvailablityListSaveUpdateDeleteMaster(
      //   menuAvailablityListSaveUpdateDeleteMaster.map(items => ({
      //     ...items,
      //     slotId: items.slotId && items.slotId.filter(object1 => {
      //       return menuavailityList.data?.data.map(object2 => ({
      //         ...object2,
      //         slotTime: object2.slotTime.some(object3 => {
      //           object1["itemAvailablity"] = true;
      //           object1["itemAvailablity"] = false;
      //           return parseInt(object1.slotId) === parseInt(object3.slotId) ?
      //             { ...object1["itemAvailablity"] = true }
      //             :
      //             { ...object1["itemAvailablity"] = false }
      //         })
      //       }
      //       ));
      //     })
      //   })));

    } else {
      // setMenuAvailablityListSaveUpdateDeleteMaster(
      //   menuAvailablityListSaveUpdateDeleteMaster.map(items => ({
      //     ...items,
      //     slotId: items.slotId.map(object1 => {
      //       return { ...object1, itemAvailablity: true }
      //     })
      //   })));

      await setMenuAvailablityListSaveUpdateDeleteMaster(menuAvailablityListSaveUpdateDeleteMaster =>
        menuAvailablityListSaveUpdateDeleteMaster.map(obj => {
          obj["slotId"] = [];
          return { ...obj };
        }),
      );
    }

    // setMenuAvailablityListSaveUpdateDeleteMaster(
    //   menuAvailablityListSaveUpdateDeleteMaster.map(items => ({
    //     ...items,
    //     slotId: items.slotId.map((itemss) => {
    //       return itemss.slotId
    //     })
    //       == menuavailityList.data?.data?.map((items2) => {
    //         return items2.slotId
    //       }) ?
    //       // obj["slotId"] = enablebollean;
    //       // return { ...obj };
    //       { ...itemss, itemAvailablity: true }
    //       :
    //       { ...itemss, itemAvailablity: false }
    //   }))
    // );

    console.log("setMenuAvailablityListSaveUpdateDeleteMaster456", menuAvailablityListSaveUpdateDeleteMaster);
    await setFoodItemTiming(true);
    console.log("vijay", menuSubmenuItems);
  };

  const svg1 = (
    <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <rect x="0" y="0" width="24" height="24"></rect>
        <circle fill="#000000" cx="5" cy="12" r="2"></circle>
        <circle fill="#000000" cx="12" cy="12" r="2"></circle>
        <circle fill="#000000" cx="19" cy="12" r="2"></circle>
      </g>
    </svg>
  );


  const onClose = () => {
    setMainMenuModal(!mainMenuModal);
  };



  const CloseImage = () => {
    setOpenImagePopup(!openImagePopup);
  };

  const handleBack = () => {
    setActiveStep(activeStep - 1);
  };

  const renderItem = ({ item, collapseIcon, handler }) => {
    return (
      <div>
        {handler}
        {collapseIcon}
        {item.mainmenu}
      </div>
    );
  };


  const stylescheck = () => {
    let maxWidth = "";
    if (menuFoodItemModal) {
      return maxWidth == "500px";
    } else if (subMenuModal) {
      return maxWidth == "700px";
    } else {

    }
  }

  return (
    <>
      {/* 
      <h3 className="card-title">Menu Management -  {selectedOutlet?.label} </h3>
      <br /> */}

      <div className="row">
        <div className="col-md-4">
          <Card>
            <Card.Header className="card-title">
              Category List {""}
              <Button variant="success dark btn-sm" onClick={() => {
                // setMenuFoodItemModal(false),
                //  setSubMenuModal(false),
                setMainMenuModal(true)
              }
              }>
                <i class="fas fa-plus">Menu </i>
              </Button>
              <br />
              <Button
                variant="success dark btn-sm"
                onClick={() => {

                  getMenuMasterListMasterApi();
                  // setMenuFoodItemModal(false),
                  setSubMenuModal(true)
                  // setMainMenuModal(true)
                }
                }>
                <i class="fas fa-plus">Sub-Menu</i>{" "}
              </Button>
            </Card.Header>
            <br />

            {menuMasterList && menuMasterList.map((cart, key) => {
              
              console.log("cart", cart)
              return <Accordion
                className={rootClass}
                // expanded={expanded === name}
                onChange={handleChange()}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                  onClick={() => {
                    // 
                    // console.log("",)
                    setMenuSubmenuItems({
                      selectedMainmenuItem: cart?.menuName,
                      menuName: cart?.menuName,
                      selectedMainmenuItemValue: cart?.menuId
                    });
                  }}
                >
                  <Typography
                    style={{ color: "white", fontSize: "large" }}
                    onClick={() => {
                      setMenuSubmenuItems({
                        selectedMainmenuItem: cart?.menuName,
                        menuName: cart?.menuName,
                        selectedMainmenuItemValue: cart?.menuId
                      });
                    }}
                  >
                    {cart?.menuName} </Typography>
                  {/* <i
                    style={{ paddingLeft: "175px", marginLeft: "0px", color: "black" }}
                    className="ti-plus"
                  ></i> */}
                </AccordionSummary>

                {cart?.subMenu && cart?.subMenu.map((items, index) => {
                  
                  // console.log("itemsvj", items)
                  // console.log("itemsvj", items?.subMenuName)
                  return <AccordionDetails
                    onClick={() => {
                      // 
                      // console.log("currentindex", index)
                      // console.log("currentindex", items)
                      // console.log("currentindexitems", items?.subMenuItem)
                      setMenuSubmenuItems({
                        menuId: items?.menuId,
                        selectedSubmenuItem: items?.subMenuName,
                        subMenuId: items?.subMenuId,
                        selectedMainmenuItem: menuSubmenuItems?.selectedMainmenuItem,
                        selectedSubmenuItemValue: items?.subMenuId,
                      });
                      setSelectedFoodSubmenuItem(items?.subMenuItem);
                    }}
                  >
                    <Typography style={{ color: "white", fontSize: "large" }}
                      onClick={() => {
                        // 
                        // console.log("currentindex", index)
                        // console.log("currentindex", items)
                        // console.log("currentindexitems", items?.subMenuItem)
                        setMenuSubmenuItems({
                          menuId: items?.menuId,
                          selectedSubmenuItem: items?.subMenuName,
                          subMenuId: items?.subMenuId,
                          selectedMainmenuItem: menuSubmenuItems?.selectedMainmenuItem,
                          selectedSubmenuItemValue: items?.subMenuId,
                        });
                        setSelectedFoodSubmenuItem(items?.subMenuItem);
                      }}
                    >
                      {items?.subMenuName}
                    </Typography>
                    {/* <i
                      style={{ paddingLeft: "257px", color: "black", fontSize: "larger" }}
                      className="ti-plus"
                      onClick={() => {
                        setActiveStep(0);
                        setMenuFoodItemModal(true);
                        setMenuSubmenuItems({
                          selectedSubmenuItem: items?.subMenuName,
                          subMenuId: items?.subMenuId,
                          menuId: items?.menuId,
                          menuName: items?.menuName,
                          subMenuName: items?.subMenuName
                        })
                      }}
                    ></i> */}
                    <br />
                  </AccordionDetails>
                })}
              </Accordion>
            })}

            <br />

          </Card>
        </div>
        <div className="col-md-8">
          <Card>
            <Card.Header className="card-title">
              {/* Item */}
              {
                `${menuSubmenuItems?.selectedMainmenuItem || ""} - ${menuSubmenuItems?.selectedSubmenuItem || ""}
                `
              }
              {/* // ${menuSubmenuItems?.selectedSubmenuItem || ""} */}
              <Button
                className="me-2"
                variant="success dark btn-sm"
                onClick={() => {
                  
                  console.log("menuSubmenuItems?.selectedSubmenuItem ", menuSubmenuItems)
                  setMenuSubmenuItems({
                    selectedIndividualFoodItemName: ""
                  });
                  getMenuMasterListMasterApi();
                  setActiveStep(0);
                  <>
                    {(menuSubmenuItems?.selectedSubmenuItem != "" && menuSubmenuItems?.selectedSubmenuItem != undefined) ?
                      setMenuFoodItemModal(true)
                      :
                      swal("Oops", "Choose Menu and Sub menu For add item", "error")
                    }
                  </>
                }}
              >
                <i class="fas fa-plus"
                  onClick={() => {
                    setMenuSubmenuItems({
                      selectedIndividualFoodItemName: ""
                    });
                  }}
                >Add Item </i>{" "}
              </Button>
            </Card.Header>
            <Card.Body>
              <Table responsive>
                <thead>
                  <tr>
                    <th>
                      <strong>ITEM NAME</strong>
                    </th>
                    <th>
                      <strong>PRICE</strong>
                    </th>

                    <th>
                      <strong>TYPE</strong>
                    </th>

                    {/* <th>
                      <strong>QTY</strong>
                    </th> */}
                    {/* <th>
                      <strong>ITEM</strong>
                    </th> */}
                    <th>
                      <strong>ACTIONS</strong>
                    </th>

                  </tr>
                </thead>


                <tbody>
                  {selectedFoodSubmenuItem && selectedFoodSubmenuItem.length > 0
                    && selectedFoodSubmenuItem.map((items, index) => {
                      console.log("items?.subMenuId", items)
                      return <>
                        <tr>
                          <td>{items?.itemName}</td>
                          <td>{items?.itemPrice}</td>
                          <td>
                            <Badge variant="success light">Veg</Badge>
                          </td>
                          {/* <td>
                      {
                        <img
                          src={food1}
                          onClick={() => {
                            setOpenImagePopup(!openImagePopup);
                            setTempModalPopupValue(food1);
                          }}
                          width="40%"
                          height="40%"
                          target="blank"
                        ></img>
                      }
                    </td> */}

                          <td>
                            <i
                              onClick={() => {
                                
                                console.log("items?.subMenuId", items);
                                console.log("menuSubmenuItems", menuSubmenuItems);
                                // selectedIndividualFoodItemName
                                setMenuSubmenuItems({
                                  selectedSubmenuItemValue: items?.subMenuId,
                                  subMenuId: items?.subMenuId,
                                  selectedSubmenuItem: menuSubmenuItems?.selectedSubmenuItem,
                                  selectedIndividualFoodItemName: items?.itemName,
                                  startTime: items?.startTime || new Date(),
                                  endTime: items?.endTime || new Date(),
                                  itemDesc: items?.itemDesc,
                                  itemName: items?.itemName,
                                  itemPrice: items?.itemPrice,
                                  itemQuantity: items?.itemQuantity,
                                  itemType: items?.itemType == "veg" ? true : false,
                                  itemFoodPath: items?.itemFoodPath,
                                  itemFoodImage: items?.itemFoodImage,
                                  varient: items?.varient,
                                  itemId: items?.itemId,
                                  status: items?.status,
                                  menuId: items?.menuId,
                                  menuName: items?.menuName,
                                  selectedMainmenuItem: items?.menuName
                                });
                                setMenuFoodItemModal(true);
                              }
                              }
                              style={{ fontSize: "large" }}
                              className="ti-pencil"
                            ></i>

                            <i
                              onClick={() => {
                                
                                console.log("items?.subMenuId", items);
                                console.log("items?.subMenuId", items?.itemId)
                                console.log("menuSubmenuItems", menuSubmenuItems);
                                // setMenuSubmenuItems(menuSubmenuItems => {
                                //   menuSubmenuItems["selectedIndividualFoodItem"] = items?.itemId;
                                //   return { ...menuSubmenuItems };
                                // });
                                setMenuSubmenuItems(
                                  {
                                    ...menuSubmenuItems["selectedIndividualFoodItem"] = items?.itemId,
                                    ...menuSubmenuItems["selectedIndividualFoodItemName"] = items?.itemName,

                                    ...menuSubmenuItems["menuId"] = menuSubmenuItems?.menuId,
                                    ...menuSubmenuItems["selectedMainmenuItem"] = menuSubmenuItems?.selectedMainmenuItem,
                                    ...menuSubmenuItems["selectedSubmenuItem"] = menuSubmenuItems?.selectedSubmenuItem,
                                    ...menuSubmenuItems["selectedSubmenuItemValue"] = menuSubmenuItems?.selectedSubmenuItemValue,
                                    ...menuSubmenuItems["subMenuId"] = menuSubmenuItems?.subMenuId
                                  }
                                );
                                // setMenuSubmenuItems(menuSubmenuItems => {
                                //   return {
                                //     ...menuSubmenuItems,
                                //     selectedIndividualFoodItem: items?.itemId
                                //   };
                                // });
                                // setMenuSubmenuItems({
                                // outletCode: items?.outletCode,
                                // menuId: items?.menuId,
                                // subMenuId: items?.subMenuId,
                                // itemId: items?.itemId,
                                // status: items?.status,
                                // selectedSubmenuItem: items?.itemName,
                                // startTime: items?.startTime || new Date(),
                                // endTime: items?.endTime || new Date(),
                                // itemDesc: items?.itemDesc,
                                // itemName: items?.itemName,
                                // itemPrice: items?.itemPrice,
                                // itemQuantity: items?.itemQuantity,
                                // itemType: items?.itemType,
                                // itemFoodPath: items?.itemFoodPath,
                                // itemFoodImage: items?.itemFoodImage,
                                // varient: items?.varient,
                                // items?.itemDesc
                                // });
                                getMenuAvailalbitList();
                              }
                              }
                              style={{ fontSize: "large" }}
                              className="ti-timer"
                            ></i>
                          </td>



                        </tr>
                      </>
                    })}

                  {selectedFoodSubmenuItem && selectedFoodSubmenuItem.length <= 0
                    &&
                    <div>
                      <br />
                      No Data Found
                    </div>
                  }
                </tbody>
              </Table>
            </Card.Body>
          </Card>
        </div>
      </div>

      <Modal
        isOpen={mainMenuModal || subMenuModal || menuFoodItemModal || foodItemTiming || openImagePopup}
        toggle={() => onClose()}
        style={{ maxWidth: (menuFoodItemModal && "1000px" || subMenuModal && "700px" || foodItemTiming && "1200px") }}
        backdrop="static" >

        <ModalHeader>
          {mainMenuModal && "Add Main Menu" ||
            subMenuModal && "Add Sub Menu" ||

            menuFoodItemModal &&
            (menuSubmenuItems?.selectedIndividualFoodItemName == undefined || menuSubmenuItems?.selectedIndividualFoodItemName == "") ?
            `Add Item -  ( ${menuSubmenuItems?.selectedMainmenuItem} - ${menuSubmenuItems?.selectedSubmenuItem})`
            : `Update Item   -  ( ${menuSubmenuItems?.selectedMainmenuItem} - ${menuSubmenuItems?.selectedSubmenuItem} - ${menuSubmenuItems?.selectedIndividualFoodItemName} )`
            ||
            foodItemTiming && `Menu Availablity -  ${menuSubmenuItems?.selectedIndividualFoodItemName} -  ` ||
            openImagePopup && "View Food Image"
          }
          <br />
          {menuFoodItemModal && <i
            className="ti-close"
            onClick={() => {
              setMenuFoodItemModal(false);
              setMenuSubmenuItems({
                selectedIndividualFoodItemName: "",
                menuId: "",
                menuName: "",
                selectedSubmenuItem: "",
                selectedSubmenuItemValue: "",
                subMenuId: "",
                selectedMainmenuItem: "",
                selectedMainmenuItemValue: ""
              });
              // setMenuSubmenuItems ({});
              getMenuMasterListMasterApi();
            }}
            style={{ paddingLeft: "900px",paddingBottom: "500px",color: "red", fontSize: "medium" }}
          ></i>
          }

          {foodItemTiming &&
            <>
              <br />
              <div className="row">
                <div className="col-sm-6 col-md-4 col-xl-3">
                  <Select
                    // IsMulti={true}
                    options={dropdownMaster}
                    // options={outletRolelist.filter((item) => {
                    //   return item.label != "ADMIN";
                    // })}
                    // search
                    // value={dropdownMastervalue}
                    value={dropdownMastervalue}
                    name="stateCode"
                    placeholder="Choose"
                    onChange={(event) =>
                      dropdownHandling("type", event)
                    }
                  />
                </div>

                {/* {dropdownMastervalue.value == "2" && */}
                <div className="col-sm-6 col-md-3 col-xl-3">
                  <Select
                    // IsMulti={true}
                    options={dropdownMasterDay}
                    // options={outletRolelist.filter((item) => {
                    //   return item.label != "ADMIN";
                    // })}
                    search
                    isDisabled={dropdownMastervalue?.value != "2"}
                    disabled={dropdownMastervalue?.value != "2"}
                    // value={staffvalue}
                    name="stateCode"
                    placeholder="Day"
                  // onChange={(event) =>
                  //   dropdownHandling("type", event)
                  // }
                  />
                </div>



                {/* } */}

                <div className="col-sm-6 col-md-3 col-xl-3">


                  {/* <Select
                    options={dropdownslotmaster}
                    search
                    name="stateCode"
                    placeholder="Slot"
                  /> */}
                  <Multiselect
                    options={dropdownslotmaster}
                    // selectedValues={selectedValueRegion}
                    // onSelect={this.handleRegion}
                    // onRemove={this.handleRemoveRegion}
                    showCheckbox={true}
                    closeOnSelect={false}
                    displayValue="label"
                  />
                </div>
                <div className="col-sm-6 col-md-3 col-xl-3">
                  <Button variant="primary"
                    // style={{ marginLeft: "352px" }}
                    onClick={() => {
                      // swal("Success!", "Time Slots Updated", "success");
                      apiMasterCallOfmenuAvailablityListSaveUpdateDeleteMaster();
                      // setFoodItemTiming(!foodItemTiming);
                      // console.log("current", menuAvailablityListSaveUpdateDeleteMaster);
                    }} >Update Slot</Button>
                </div>

              </div>


              {/* <label style={{ paddingLeft: "290px" }}>
                <input type="checkbox"
                  checked={checkeditem}
                  onChange={() => {
                    alldayallsotBoolean();
                  }}
                />
                All Day All Slot  {checkeditem}
              </label> */}


              {/* const [checkeditem, setCheckeditem] = useState(false); */}

            </>
          }

        </ModalHeader>
        <ModalBody>
          {mainMenuModal &&
            <div className="row">
              <div className="col-sm-8 col-md-8 col-xl-8">
                <FormGroup>
                  <Label for="menu">
                    Main Menu Name
                    <span class="text-danger">*</span>
                  </Label>
                  <Input
                    type="text"
                    name="menu"
                    id="menu"
                    placeholder="Enter  Menu"
                    maxLength="40"
                    required
                    autoComplete="off"
                    onChange={(e) => {
                      // 
                      setMenuSubmenuItems(
                        {
                          menuName: e.target.value
                        }
                      )
                    }
                    }
                  />
                </FormGroup>
              </div>
            </div>}
          {subMenuModal &&
            <div className="row">
              <div className="col-sm-6 col-md-6 col-xl-5">
                <FormGroup>
                  <Label for="itemqty">
                    Menu Name<span class="text-danger">*</span>
                  </Label>
                  <Select
                    options={category}
                    search
                    name="stateCode"
                    placeholder="Choose Menu"
                    autoComplete="off"
                    value={outletvalue}
                    onChange={(event) => {
                      setOutletvalue({
                        label: event.label,
                        value: event.value
                      });
                    }}
                  />
                </FormGroup>
              </div>
              <div className="col-sm-6 col-md-6 col-xl-5">
                <FormGroup>
                  <Label for="submenu">
                    Sub Menu
                    <span class="text-danger">*</span>
                  </Label>
                  <Input
                    type="text"
                    name="submenu"
                    id="submenu"
                    placeholder="Enter Sub Menu"
                    maxLength="40"
                    required
                    autoComplete="off"

                    onChange={(e) => {
                      // 
                      setMenuSubmenuItems(
                        {
                          subMenuName: e.target.value
                        }
                      )
                    }}

                  />
                </FormGroup>
              </div>
            </div>}
          {menuFoodItemModal &&
            <>
              <Stepper
                alternativeLabel
                nonLinear
                className="stepper-rtl"
                activeStep={activeStep}
              >
                {steps.map((step, index) => {
                  const labelProps = {};
                  const stepProps = {};
                  if (isStepOptional(index)) {
                    labelProps.optional = (
                      <Typography
                        variant="caption"
                        align="center"
                        style={{ display: "block" }}
                      >
                        optional
                      </Typography>
                    );
                  }
                  if (isStepSkipped(index)) {
                    stepProps.completed = false;
                  }
                  return (
                    <Step key={step} {...props}>
                      <StepButton onClick={() => handleStep(index)} {...stepProps}>
                        {step}
                      </StepButton>
                    </Step>
                  );
                })}
              </Stepper>
              <div className="pl-40">
                <p>{getStepContent(activeStep)}</p>
              </div>
            </>}

          {openImagePopup &&
            <>
              {tempModalPopupValue != "" ? (
                <>
                  {chkImgFile(tempModalPopupValue) ? (
                    <>
                      <a href={tempModalPopupValue} download target="_blank">
                        Download Image
                      </a>
                      <br />
                      <ReactPanZoom image={tempModalPopupValue} alt="image" />
                    </>
                  ) : (
                    <iframe
                      src={tempModalPopupValue}
                      width="100%"
                      height="400px"
                    ></iframe>
                  )}
                </>
              ) : (
                <p>File Not Available</p>
              )}
            </>
          }

          {foodItemTiming &&
            <div className="row">
              {menuAvailablityListSaveUpdateDeleteMaster.map((items) => {
                
                return (
                  <Col xl="4">
                    <Card className="text-white  times-card">
                      <CardTitle className="text-white bg-secondary">
                        {items.dayName}
                        {/* <label style={{ paddingLeft: "150px" }}>
                          <input type="checkbox"
                            checked={checkeditem}
                          />{""}
                          Day Slot
                        </label> */}
                      </CardTitle>
                      <CardBody>
                        {items?.slotTime && items?.slotTime.map((data) => {
                          // 
                          // console.log("data", data);
                          return (
                            <>
                              {/* {data?.itemAvailablity === true && */}
                              <div>
                                <h4>{data.slotName} :
                                  <span className="badge badge-lg bg-green time-chip mr-2">
                                    {data.startTime} - {data.endTime}
                                  </span>
                                  {/* <label style={{ paddingLeft: "12px" }}>
                                    <input type="checkbox"
                                      checked={data?.itemAvailablity === true}
                                      onChange={() => { nestedLevelItemCheck(items?.dayId, data) }}
                                    />
                                  </label> */}
                                </h4>
                              </div>
                              {/* } */}
                            </>
                          );
                        })}
                      </CardBody>
                    </Card>
                  </Col>
                );
              })}
            </div>
          }
        </ModalBody>

        <ModalFooter>
          {mainMenuModal &&
            <>
              <Button variant="primary"
                disabled={menuSubmenuItems?.menuName == ""}
                onClick={() => { saveMenuSubmenu("Maninmenu") }} >Save
              </Button>

              <Button variant="danger light"
                onClick={() => {
                  // setMenuFoodItemModal(false),
                  //  setSubMenuModal(false),
                  setMainMenuModal(false)
                }
                }
              >
                Close
              </Button>
            </>}

          {subMenuModal &&
            <>
              <Button variant="primary"
                disabled={menuSubmenuItems?.subMenuName == ""}
                onClick={() => { saveMenuSubmenu("SubManinmenu") }} >Save</Button>
              <Button variant="danger light"
                onClick={() => {
                  // setMenuFoodItemModal(false),
                  setSubMenuModal(false)
                  // setMainMenuModal(false)
                }
                }
              >
                Close
              </Button>
            </>
          }

          {menuFoodItemModal &&
            <>
              {activeStep === 1 &&
                <Button
                  variant="secondary"
                  onClick={handleBack}
                >
                  Back
                </Button>}

              {activeStep === 0 ?
                // <Button variant="primary" onClick={() => { setActiveStep(1) }}>
                //   Save & Addons
                // </Button> :
                <Button variant="primary"
                  disabled={menuSubmenuItems?.itemName == "" || menuSubmenuItems?.itemPrice == ""}
                  onClick={() => { submitFoodItemApi() }}>
                  Submit
                </Button> : ""
              }

            </>
          }

          {foodItemTiming &&
            <>


              <Button variant="danger light"
                onClick={() => {
                  setFoodItemTiming(false)
                }
                }
              >
                Cancel
              </Button>
            </>
          }



        </ModalFooter>
      </Modal>
    </>
  );
};
export default FoodMenuManagment;